import React from 'react';
import AccountSuggestionItem, {
  SuggestionType
} from '@cube3/cubicle/src/core/molecules/SuggestionItems/AccountSuggestionItem';
import { TeamSuggestionItemRow } from '../../../../AdminCenter/views/WorkspaceTeamsView/prefabs/TeamSuggestionItemRow';
import { SizeVariants } from '@cube3/cubicle/src/theme/themes';
import { ResourceSuggestionItem } from '@cube3/cubicle/src/core/molecules/SuggestionItems/ResourceSuggestionItem';
import { ContractSuggestionItem } from '@cube3/cubicle/src/core/molecules/SuggestionItems/ContractSuggestionItem';
import { Tag } from '@cube3/cubicle/src/core/atoms/Tag/Tag';
import { ColorVariant } from '@cube3/cubicle/src/core/atoms/Color';
import { ContextMenuListItem } from '@cube3/cubicle/src/core/molecules/ContextMenu/ContextMenuListItem';
import { Typography } from '@cube3/cubicle/src/core/atoms/Typography';
import { SuggestionItem } from '../SuggestionsPickerBase';

export const makeSelectedItem = (
  value: string | SuggestionItem,
  type: SuggestionType,
  locked = false,
  onCrossClick?: (sug?) => void
) => {
  if (!value) return null;

  const config = {
    size: SizeVariants.sm as const,
    key: (locked ? 'locked_' : 'selected_') + JSON.stringify(value),
    label: typeof value === 'string' ? value : value.id,
    onCrossClick: locked ? undefined : onCrossClick,
    chipStyle: (locked ? 'outlined' : 'filled') as 'outlined' | 'filled',
    color: (locked ? 'ghost' : 'overlayColor') as ColorVariant
  };

  switch (type) {
    case 'team':
      return <Tag {...config} sublabel={'Team'} />;
    case 'contract':
    case 'project':
    case 'folder':
      return <Tag {...config} iconLeft={type} />;
    default:
      return <Tag {...config} />;
  }
};

export const makeSuggestionItem = (suggestion, showModifier = false) => {
  if (!suggestion) return null;
  switch (suggestion.type) {
    case 'email':
    case 'account':
      return (
        <AccountSuggestionItem item={suggestion} showModifier={showModifier} />
      );
    case 'team':
      return (
        <TeamSuggestionItemRow
          item={suggestion}
          maxCount={8}
          size={SizeVariants.sm}
          showModifier={showModifier}
        />
      );
    case 'contract':
      return (
        <ContractSuggestionItem
          item={suggestion}
          showAttachments={false}
          showDate
        />
      );
    case 'asset':
    case 'project':
    case 'folder':
      return (
        <ResourceSuggestionItem item={suggestion} showModifier={showModifier} />
      );
    default:
      return (
        <ContextMenuListItem
          rightIcon={
            suggestion.disabled && (
              <Typography>{suggestion.disabled.toUpperCase()}</Typography>
            )
          }
          disabled={suggestion.disabled}
          showChevron={false}
          name={suggestion.id || suggestion.value || suggestion.display_name}
          onClick={suggestion.onClick}
          modifiers={showModifier && !suggestion.disabled ? 'Enter' : undefined}
          disableHover
        />
      );
  }
};
